import { makeSelectLoginUserInEvent } from "modules/event/usersInEvent/selectors";
import { selectCurrentSpaceId } from "modules/space/redux/selectors";
import React from "react";
import { useSelector } from "react-redux";

interface ITheaterDataLoaderProps {
  setIsLoading: (isLoading: boolean) => void;
}

const TheaterDataLoader = ({ setIsLoading }: ITheaterDataLoaderProps) => {
  const currentSpaceId = useSelector(selectCurrentSpaceId);
  const currentUserInEvent = useSelector(makeSelectLoginUserInEvent());

  React.useEffect(() => {
    if (currentSpaceId && currentUserInEvent) {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSpaceId, currentUserInEvent]);

  return null;
};

export default TheaterDataLoader;
